/**
 * File: apps/qbench-cp/reactapp/src/shared/components/QBenchCurrency/index.jsx
 *
 * Purpose: Formats and renders a numeric quantity as currency using the tenant's configured
 *     currency code.
 *
 * Scope: Shared QBenchCurrency component.
 *
 * Tags: customer-portal
 *
 * Overview: Reads the current currency code via the useCurrency hook and passes it, along with
 *     the numeric quantity prop (coerced with Number and defaulted to 0), to
 *     react-currency-formatter's Currency component for display.
 *
 * Exports: QBenchCurrency (default export).
 */

import Currency from 'react-currency-formatter';
import { useCurrency } from 'shared/hooks/api/billing';

const QBenchCurrency = ({ quantity }) => {
    const { data: { code: currencyCode } } = useCurrency()

    return <Currency currency={currencyCode} quantity={Number(quantity) ?? 0} />
}

export default QBenchCurrency;